import type { Message } from '../../../api/types';
import { formatRelativeTime } from '../../../util/dateUtils';
import { MarkdownRenderer, Citations } from '../../shared';
import styles from './MessageBubble.module.css';

export interface MessageBubbleProps {
  message: Message;
  variant?: 'default' | 'compact' | 'floating';
  showTimestamp?: boolean;
}

export function MessageBubble({ 
  message, 
  variant = 'default',
  showTimestamp = false 
}: MessageBubbleProps) {
  const { role, message: content, created_at, files } = message;
  const bubbleClass =
    role === 'assistant' ? styles.messageAssistant : styles.messageUser;

  const hasFiles = files && files.length > 0;

  return (
    <div className={`${styles.message} ${bubbleClass} ${styles[variant]}`}>
      <MarkdownRenderer className={styles.messageContent} content={content} />
      {hasFiles && (
        <Citations files={files} />
      )}
      {showTimestamp && created_at && (
        <span className={styles.timestamp} title={new Date(created_at).toLocaleString()}>
          {formatRelativeTime(created_at)}
        </span>
      )}
    </div>
  );
}